// Multilingual Translations and Text Generation for Estimates, Receipts, and Invoices
// Supports French (FR) and English (EN)

export const DOC_TRANSLATIONS = {
  fr: {
    // Types
    type_estimate: "Devis Estimatif",
    type_receipt: "Reçu Officiel de Paiement",
    type_invoice: "Facture Officielle",
    badge_estimate: "DEVIS ESTIMATIF",
    badge_receipt: "REÇU DE PAIEMENT",
    badge_invoice: "FACTURE OFFICIELLE",

    // Organization
    org_title: "JNIC",
    org_tagline: "Services d'Orientation & Préparation à l'Immigration Canadienne",
    org_contact: "Douala, Cameroun · Montréal, Canada · info@jnic.org · jnic.org",

    // Headers & Metadata
    ref_label: "Réf :",
    num_label: "N°",
    receipt_num_label: "Reçu N°",
    date_label: "Date :",
    validity_label: "Validité :",
    validity_suffix: "jours",
    generated_on: "Document généré électroniquement le",

    // Receipt specifics
    received_from: "Reçu de (Candidat)",
    amount_paid: "Montant Réglé / Encaissé",
    amount_paid_badge: "PAYÉ",
    balance_due: "Solde Restant Dû",
    payment_method: "Mode de Règlement",
    payment_status: "Statut du Règlement",
    payment_date: "Date de Règlement",
    payment_ref: "Réf. Transaction / Reçu",
    accounting_stamp: "Service Comptabilité & Règlement",
    authorized_signature: "Cachet officiel & Signature autorisée",
    payment_certified: "Ce document certifie la réception effective du montant ci-dessus au titre du dossier d'immigration du candidat.",

    // Payment methods
    method_compte_bloque: "Compte bloqué (Fonds consignés et garantis)",
    method_virement: "Virement bancaire",
    method_especes: "Espèces (Caisse JNIC)",
    method_carte: "Carte bancaire (Visa / Mastercard)",
    method_cheque: "Chèque certifié",

    // Payment statuses
    status_fully_paid: "Soldé (Paiement Intégral)",
    status_partial: "Acompte Versé (Paiement Partiel)",
    status_pending: "En attente de compensation bancaire",

    // Candidate Card
    candidate_principal: "Candidat Principal",
    procedure: "Procédure",
    proc_express_single: "Entrée Express (Seul)",
    proc_express_family: "Entrée Express (Famille)",
    proc_work_contract: "Contrat de travail Canada",
    residence: "Résidence :",
    financial_scheme: "Régime Financier",
    family_composition: "Composition Familiale",
    blocked_account_tag: "Compte bloqué (6 mois max)",
    escrow_guaranteed: "Fonds sous séquestre garanti",
    couple: "Couple",
    single: "Célibataire",
    child_singular: "enfant",
    child_plural: "enfants",
    total_persons: "Total :",
    persons_unit: "personne(s)",
    final_deliverables: "Livrables Finaux Remis",
    applied_rates: "Taux Appliqués",
    flight_included: "✈️ Billet d'avion inclus",
    work_contract_delivered: "📄 Contrat de travail remis",

    // Work Contract Section
    wc_banner_title: "Procédure Contrat de Travail Canada · Compte Bloqué",
    wc_banner_tag: "Fonds Protégés",
    wc_banner_desc: "Structure forfaitaire garantie en compte bloqué avec deux dépenses exclusives. Billet d'avion et contrat de travail remis au client en fin de procédure.",
    wc_fixed_total: "Forfait Global Fixé",
    wc_table_title: "Décomposition des Deux Dépenses de la Procédure",
    col_expense: "Poste de Dépense",
    col_scheme: "Régime",
    col_inclusions: "Inclusions Clés",
    col_amount_fcfa: "Montant (FCFA)",

    wc_item1_badge: "Poste 1",
    wc_item1_title: "Frais de traitement, Dossier EIMT & Caution employeur",
    wc_item1_detail1: "• Frais officiels pour l'EIMT (Étude d'Impact sur le Marché du Travail).",
    wc_item1_detail2: "• Caution obligatoire versée à l'entreprise qui recrute ({sector}).",
    wc_item1_detail3: "• Billet d'avion pour le Canada INCLUS sans aucun surcoût.",
    wc_item1_detail4: "• À la fin de la procédure, il est remis directement au client son billet d'avion et son contrat de travail.",
    wc_item1_incl: "✈️ Billet d'avion\n📄 Contrat de travail\n🏢 Caution entreprise",

    wc_item2_badge: "Poste 2",
    wc_item2_title: "Assistance à la réalisation de la preuve de fonds",
    wc_item2_detail1: "• Accompagnement technique, structuration bancaire et montage complet de la preuve de fonds requise pour la validation finale du dossier.",
    wc_item2_incl: "🏛️ Montage financier\n📋 Conformité bancaire",

    // Blocked Account Protocol Cards
    protocol_title: "PROTOCOLE DE SÉCURISATION EN COMPTE BLOQUÉ & ENGAGEMENTS",
    protocol_tag: "Sécurité Intégrale",
    card1_title: "🔒 Compte Bloqué (6 mois max)",
    card1_desc: "Les fonds sont consignés sur un compte bloqué dédié. Le blocage dure 6 mois maximum (durée contractuelle de la procédure).",
    card2_title: "🛡️ Remboursement Intégral",
    card2_desc: "Si la procédure n'aboutit pas, le client est entièrement remboursé. Si le délai de 6 mois est dépassé, le client est également entièrement remboursé.",
    card3_title: "✈️ Billet Inclus",
    card3_desc: "Le ou les billets d'avion pour le Canada sont d'ores et déjà compris dans les frais de traitement, sans aucun surcoût.",
    card4_title: "📄 Remise au Client",
    card4_desc: "À la clôture de la procédure, il est remis au client en main propre son billet d'avion et son contrat de travail.",

    // Express Entry Sections
    ee_sec1_title: "1. Évaluations Préalables & Tests de Langue",
    col_designation: "Désignation",
    col_qty: "Quantité",
    col_unit_price: "Prix Unitaire",
    ee_lang_test_title: "Test de langue officiel (TCF Canada / TEF Canada)",
    ee_lang_test_desc: "Payé directement au centre d'examen agréé (IFC / CCF)",
    ee_univ_title: "Procédure d'authentification des diplômes à l'université",
    ee_univ_desc: "Frais administratifs moyens de transmission du relevé de notes",
    ee_wes_title: "Évaluation comparative des diplômes WES (Canada)",
    ee_wes_desc: "Rapport officiel d'évaluation des diplômes d'études (EDE)",

    ee_sec2_title: "2. Frais Gouvernementaux Officiels (IRCC) & Visite Médicale",
    col_currency_orig: "Devise Origine",
    col_equiv: "Contre-valeur",
    ee_medical_title: "Visite médicale préalable / e-Medical (Clinique OIM / Agréée)",
    ee_medical_desc_single: "198 $US (Examen clinique, radiographie pulmonaire, analyses de laboratoire)",
    ee_medical_desc_family: "Adultes: {adults}$US | Enfants: {kids}$US",
    ee_ircc_desc: "Frais exigés par le Ministère de l'Immigration du Canada (IRCC)",

    ee_sec3_title: "3. Honoraires d'Accompagnement & Options Spécifiques",
    col_service: "Prestation",
    col_status: "Statut",
    col_conditions: "Conditions",
    included_tag: "Inclus",
    option_tag: "Option",
    formula_family: "Formule Famille",
    formula_single: "Formule Individuelle",
    ee_jnic_fees_title: "Honoraires d'accompagnement & Préparation linguistique JNIC",
    ee_jnic_fees_desc: "Diagnostic de profil, coaching TCF/TEF, structuration des dossiers, suivi continu",
    ee_work_exp_title: "Assistance à la formalisation de l'expérience professionnelle",
    ee_work_exp_desc: "Structuration des contrats, attestations d'emploi et conformité CNP",
    ee_funds_title: "Assistance & Structuration de la preuve de fonds bancaire",
    ee_funds_desc: "7% du montant officiel de subsistance exigé par IRCC ({amount} $CAD)",
    ee_contingency_title: "Réserve pour imprévus administratifs",
    ee_contingency_desc: "Traductions certifiées, légalisations, frais notariés, coursiers sécurisés",
    advised_reserve: "Provision conseillée",

    // Discounts
    discount_badge: "Rabais accordé",
    discount_sub: "Déduction directe appliquée sur le montant global du dossier",
    discount_deducted: "Déduit",
    discount_courtesy: "Geste commercial",
    discount_applied: "RABAIS APPLIQUÉ",
    gross_subtotal: "Sous-total brut :",

    // Payment Schedule
    schedule_title: "ÉCHÉANCIER DE PAIEMENT DES HONORAIRES D'ACCOMPAGNEMENT (3 TRANCHES)",
    total_fees_label: "Total Honoraires :",
    tranche1_title: "1ère Tranche · 25%",
    tranche1_desc: "Au début de la procédure (Lancement du dossier)",
    tranche2_title: "2ème Tranche · 25%",
    tranche2_desc: "À la réception de l'ITA (Invitation IRCC)",
    tranche3_title: "3ème Tranche · 50%",
    tranche3_desc: "À l'émission finale du Visa par IRCC",

    // Refusal Policy
    refusal_title: "Garantie & Politique de Remboursement en cas de refus :",
    refusal_body: "En cas de refus de la demande par IRCC, 50% du montant déjà versé est intégralement remboursé au client (soit {remb} FCFA restitués sur les {verse} FCFA réglés avant visa), vu que les 50% payables après l'émission du visa n'auront pas encore été versés.",

    // Grand Total
    net_total_estimate: "Total Estimatif Net de la Procédure",
    net_total_receipt: "Montant Total du Dossier",
    total_desc_with_discount: "Montant final net après déduction du rabais accordé au candidat",
    total_desc_regular: "Comprend l'ensemble des étapes de préparation, frais officiels et honoraires",
    equiv_label: "Contre-valeur :",

    // Special Notices
    ircc_funds_title: "EXIGENCE OFFICIELLE IRCC · PREUVE DE FONDS DE SUBSISTANCE",
    ircc_funds_badge: "Mise à jour IRCC",
    ircc_funds_body: "Pour valider votre Résidence Permanente avec une famille de {total} personne(s), le gouvernement canadien (IRCC) exige que votre compte bancaire personnel dispose d'un minimum légal obligatoire non engagé de :",
    ircc_funds_label: "Fonds exigés à l'arrivée :",
    ircc_funds_disclaimer: "* Ce montant demeure votre argent propre et n'est versé à aucun organisme. Il doit simplement être justifié par attestation bancaire lors du dépôt.",

    post_arrival_title: "SERVICES POST-ARRIVÉE AU CANADA (OPTIONNEL À LA CARTE)",
    post_arrival_body: "Accueil personnalisé à l'aéroport, accompagnement au logement de transition, assistance à l'obtention du Numéro d'Assurance Sociale (NAS / SIN), ouverture du compte bancaire canadien, carte d'assurance maladie (RAMQ / OHIP) et forfait téléphonique.",
    post_arrival_disclaimer: "* Prestation indépendante payable uniquement après obtention du visa et confirmation de voyage.",

    // Legal Disclosures
    legal_wc_title: "Cadre de la Procédure & Protocole Compte Bloqué (Précision Réglementaire)",
    legal_wc_intro: "La présente estimation financière pour la procédure de contrat de travail repose sur un forfait global convenu de {total} FCFA :",
    legal_wc_p1: "Traitement du dossier d'EIMT et caution versée à l'entreprise recruteuse ({sector}).",
    legal_wc_p2: "Prise en charge intégrale du ou des billet(s) d'avion pour le Canada dans l'enveloppe de traitement ({processing} FCFA).",
    legal_wc_p3: "Assistance technique et validation de la preuve de fonds bancaires ({proof_funds} FCFA).",
    legal_wc_p4: "Sécurisation intégrale des fonds sous le régime contractuel du compte bloqué. La durée de blocage des fonds est de 6 mois maximum (durée contractuelle de la procédure).",
    legal_wc_p5: "Garantie de remboursement intégral : Si la procédure n'aboutit pas, le client est entièrement remboursé. Si la durée de la procédure atteint le délai maximal de 6 mois sans aboutissement, le client est également entièrement remboursé des fonds consignés en compte bloqué.",
    legal_wc_p6: "À la fin de la procédure, il est remis directement au client son billet d'avion et son contrat de travail.",

    legal_ee_title: "Cadre d'intervention des Honoraires JNIC (Précision Légale)",
    legal_ee_intro: "Les honoraires de {fees} FCFA correspondent à un accompagnement éducatif et administratif. Ils ne constituent pas des honoraires de représentation réglementée en immigration :",
    legal_ee_p1: "Préparation au test de français : stratégie, entraînement, simulations et rétroaction.",
    legal_ee_p2: "Diagnostic du parcours et plan de préparation personnalisé.",
    legal_ee_p3: "Listes de contrôle et soutien à l'organisation des pièces justificatives.",
    legal_ee_p4: "Suivi des échéances et préparation pratique avant le départ.",
    legal_ee_p5: "Orientation vers un professionnel autorisé lorsqu'un avis juridique ou une représentation est nécessaire.",
    french_test_notice_title: "À propos du test de français :",
    french_test_notice_body: "Les frais d'examen TCF Canada sont payés séparément au centre d'examen. Les honoraires JNIC couvrent la préparation et l'entraînement, mais ne garantissent ni un score précis ni une invitation à présenter une demande.",

    // Signatures
    signature_applicant: "Le Candidat (Bon pour accord)",
    signature_applicant_receipt: "Le Candidat (Signataire)",
    signature_agency: "Pour JNIC (Direction Générale & Comptabilité)",
    signature_accounting: "Service Trésorerie & Comptabilité JNIC",
    date_and_signature: "Date & Signature :",
  },

  en: {
    // Types
    type_estimate: "Official Estimate & Budget Quote",
    type_receipt: "Official Payment Receipt",
    type_invoice: "Official Invoice",
    badge_estimate: "OFFICIAL ESTIMATE",
    badge_receipt: "PAYMENT RECEIPT",
    badge_invoice: "OFFICIAL INVOICE",

    // Organization
    org_title: "JNIC",
    org_tagline: "Canadian Immigration Advisory & Settlement Services",
    org_contact: "Douala, Cameroon · Montreal, Canada · info@jnic.org · jnic.org",

    // Headers & Metadata
    ref_label: "Ref:",
    num_label: "No.",
    receipt_num_label: "Receipt No.",
    date_label: "Date:",
    validity_label: "Validity:",
    validity_suffix: "days",
    generated_on: "Document electronically generated on",

    // Receipt specifics
    received_from: "Received From (Applicant)",
    amount_paid: "Amount Paid / Received",
    amount_paid_badge: "PAID",
    balance_due: "Balance Remaining Due",
    payment_method: "Payment Method",
    payment_status: "Payment Status",
    payment_date: "Payment Date",
    payment_ref: "Payment Ref / Slip No.",
    accounting_stamp: "Accounting & Settlements Department",
    authorized_signature: "Official Stamp & Authorized Signature",
    payment_certified: "This document certifies the official receipt of the amount stated above towards the applicant's Canadian immigration file.",

    // Payment methods
    method_compte_bloque: "Blocked Escrow Account (Protected & Guaranteed)",
    method_virement: "Bank Wire Transfer",
    method_especes: "Cash (JNIC Cashier)",
    method_carte: "Credit/Debit Card (Visa / Mastercard)",
    method_cheque: "Certified Cheque / Bank Draft",

    // Payment statuses
    status_fully_paid: "Fully Paid (Settled in full)",
    status_partial: "Deposit Received (Partial Payment)",
    status_pending: "Pending Bank Clearance",

    // Candidate Card
    candidate_principal: "Principal Applicant",
    procedure: "Procedure",
    proc_express_single: "Express Entry (Single)",
    proc_express_family: "Express Entry (Family)",
    proc_work_contract: "Canada Work Contract",
    residence: "Residence:",
    financial_scheme: "Financial Scheme",
    family_composition: "Family Composition",
    blocked_account_tag: "Blocked Account (6 months max)",
    escrow_guaranteed: "Funds held under guaranteed escrow",
    couple: "Couple",
    single: "Single",
    child_singular: "child",
    child_plural: "children",
    total_persons: "Total:",
    persons_unit: "person(s)",
    final_deliverables: "Final Deliverables Handed Over",
    applied_rates: "Applied Exchange Rates",
    flight_included: "✈️ Flight ticket included",
    work_contract_delivered: "📄 Employment contract delivered",

    // Work Contract Section
    wc_banner_title: "Canada Work Contract Procedure · Blocked Escrow Account",
    wc_banner_tag: "Protected Funds",
    wc_banner_desc: "Guaranteed flat-rate blocked escrow framework with two exclusive expenditures. Flight ticket and employment contract directly handed over to the client upon completion.",
    wc_fixed_total: "Global Fixed Fee",
    wc_table_title: "Breakdown of the Two Procedure Expenses",
    col_expense: "Expense Item",
    col_scheme: "Scheme",
    col_inclusions: "Key Inclusions",
    col_amount_fcfa: "Amount (FCFA)",

    wc_item1_badge: "Item 1",
    wc_item1_title: "Processing Fees, LMIA Application & Employer Deposit",
    wc_item1_detail1: "• Official fees for LMIA (Labour Market Impact Assessment).",
    wc_item1_detail2: "• Mandatory deposit paid to recruiting employer ({sector}).",
    wc_item1_detail3: "• One-way flight ticket to Canada INCLUDED at no extra cost.",
    wc_item1_detail4: "• Upon completion, the client is directly handed their flight ticket and official employment contract.",
    wc_item1_incl: "✈️ Flight ticket\n📄 Employment contract\n🏢 Employer deposit",

    wc_item2_badge: "Item 2",
    wc_item2_title: "Assistance with Proof of Settlement Funds",
    wc_item2_detail1: "• Comprehensive technical structuring, banking guidance, and assembly of required proof of settlement funds for final file approval.",
    wc_item2_incl: "🏛️ Financial structuring\n📋 Banking compliance",

    // Blocked Account Protocol Cards
    protocol_title: "BLOCKED ESCROW ACCOUNT PROTOCOL & COMMITMENTS",
    protocol_tag: "100% Guaranteed",
    card1_title: "🔒 Blocked Account (6 months max)",
    card1_desc: "Funds are deposited in a dedicated blocked escrow account. Fund blocking lasts a maximum of 6 months (contractual duration of the procedure).",
    card2_title: "🛡️ Full Refund Guarantee",
    card2_desc: "If the procedure does not succeed, the client is fully refunded. If the 6-month period is exceeded, the client is also fully refunded.",
    card3_title: "✈️ Flight Ticket Included",
    card3_desc: "One-way flight ticket(s) to Canada are already fully included within the processing fees, at no extra cost.",
    card4_title: "📄 Handover to Client",
    card4_desc: "At procedure closure, the client is directly handed their flight ticket and official employment contract in person.",

    // Express Entry Sections
    ee_sec1_title: "1. Preliminary Evaluations & Official Language Tests",
    col_designation: "Item Description",
    col_qty: "Quantity",
    col_unit_price: "Unit Price",
    ee_lang_test_title: "Official Language Test (TCF Canada / TEF Canada)",
    ee_lang_test_desc: "Paid directly to accredited testing center (IFC / CCF)",
    ee_univ_title: "University Degree Authentication & Transcript Transmission",
    ee_univ_desc: "Average administrative transcript transmission and verification fees",
    ee_wes_title: "Comparative Educational Credential Assessment WES (Canada)",
    ee_wes_desc: "Official Educational Credential Assessment (ECA) report",

    ee_sec2_title: "2. Official Canadian Government (IRCC) & Medical Fees",
    col_currency_orig: "Original Currency",
    col_equiv: "Approx. Value",
    ee_medical_title: "Upfront Medical Examination / e-Medical (IOM / Panel Physician)",
    ee_medical_desc_single: "198 $USD (Clinical examination, chest X-ray, and laboratory tests)",
    ee_medical_desc_family: "Adults: {adults}$USD | Children: {kids}$USD",
    ee_ircc_desc: "Official mandatory fees required by Immigration, Refugees and Citizenship Canada (IRCC)",

    ee_sec3_title: "3. Professional Advisory Retainer Fees & Specific Options",
    col_service: "Service",
    col_status: "Status",
    col_conditions: "Conditions",
    included_tag: "Included",
    option_tag: "Option",
    formula_family: "Family Package",
    formula_single: "Single Package",
    ee_jnic_fees_title: "JNIC Immigration Guidance & Language Preparation Retainer",
    ee_jnic_fees_desc: "Profile diagnostic, TCF/TEF coaching, file assembly, continuous case management",
    ee_work_exp_title: "Assistance with Professional Work Experience Formalization",
    ee_work_exp_desc: "Contracts structuring, employment certificates and NOC/TEER compliance",
    ee_funds_title: "Assistance & Structuring for Bank Proof of Settlement Funds",
    ee_funds_desc: "7% of the mandatory settlement funds required by IRCC ({amount} $CAD)",
    ee_contingency_title: "Contingency Reserve for Administrative Expenses",
    ee_contingency_desc: "Certified translations, legalizations, notarizations, secure couriers",
    advised_reserve: "Recommended reserve",

    // Discounts
    discount_badge: "Discount Granted",
    discount_sub: "Direct promotional deduction applied to the overall file total",
    discount_deducted: "Deducted",
    discount_courtesy: "Commercial courtesy",
    discount_applied: "DISCOUNT APPLIED",
    gross_subtotal: "Gross subtotal:",

    // Payment Schedule
    schedule_title: "RETAINER FEES PAYMENT SCHEDULE (3 INSTALLMENTS)",
    total_fees_label: "Total Retainer:",
    tranche1_title: "1st Installment · 25%",
    tranche1_desc: "At start of procedure (File launch)",
    tranche2_title: "2nd Installment · 25%",
    tranche2_desc: "Upon receipt of ITA (IRCC Invitation to Apply)",
    tranche3_title: "3rd Installment · 50%",
    tranche3_desc: "Upon final Visa issuance by IRCC",

    // Refusal Policy
    refusal_title: "Guarantee & Refund Policy in Case of Refusal:",
    refusal_body: "In the event of application refusal by IRCC, 50% of the amount already paid is fully refunded to the client (i.e. {remb} FCFA returned out of {verse} FCFA paid prior to visa issuance), since the remaining 50% payable upon visa issuance will not have been paid.",

    // Grand Total
    net_total_estimate: "Net Total Estimated Procedure Budget",
    net_total_receipt: "Total Dossier Amount",
    total_desc_with_discount: "Final net amount after deducting the discount granted to applicant",
    total_desc_regular: "Includes all preparatory steps, official government fees, and consulting retainer",
    equiv_label: "Approx. equivalent:",

    // Special Notices
    ircc_funds_title: "OFFICIAL IRCC REQUIREMENT · PROOF OF SETTLEMENT FUNDS",
    ircc_funds_badge: "IRCC Updated",
    ircc_funds_body: "To validate your Permanent Residence with a family of {total} person(s), the Canadian Government (IRCC) requires your personal bank account to hold an unencumbered legal minimum of:",
    ircc_funds_label: "Mandatory funds required upon arrival:",
    ircc_funds_disclaimer: "* This amount remains your personal money and is never paid to any organization. It must simply be substantiated by an official bank certificate upon file submission.",

    post_arrival_title: "POST-ARRIVAL SETTLEMENT SERVICES IN CANADA (OPTIONAL A LA CARTE)",
    post_arrival_body: "Personalized airport pickup, transitional housing guidance, Social Insurance Number (SIN / NAS) assistance, Canadian bank account setup, provincial health insurance card (RAMQ / OHIP), and mobile phone setup.",
    post_arrival_disclaimer: "* Independent settlement service payable only after visa issuance and travel confirmation.",

    // Legal Disclosures
    legal_wc_title: "Framework of Procedure & Blocked Escrow Protocol (Regulatory Notice)",
    legal_wc_intro: "This financial estimation for the work contract procedure is based on an agreed global package of {total} FCFA:",
    legal_wc_p1: "LMIA file processing and mandatory employer deposit paid to the recruiting company ({sector}).",
    legal_wc_p2: "Full coverage of one-way flight ticket(s) to Canada within the processing fees envelope ({processing} FCFA).",
    legal_wc_p3: "Technical guidance and banking assembly for proof of settlement funds ({proof_funds} FCFA).",
    legal_wc_p4: "Complete fund safeguarding under the contractual regime of a blocked escrow account. Fund blocking duration is 6 months maximum (contractual duration of the procedure).",
    legal_wc_p5: "Full refund guarantee: If the procedure does not succeed, the client is fully refunded. If the procedure reaches the maximum 6-month period without completion, the client is also fully refunded for all funds held in the blocked account.",
    legal_wc_p6: "Upon procedure completion, the client is directly handed their flight ticket and official employment contract.",

    legal_ee_title: "Scope of JNIC Consulting Retainer (Legal Notice)",
    legal_ee_intro: "Consulting fees of {fees} FCFA cover educational and administrative guidance. They do not constitute regulated immigration legal representation:",
    legal_ee_p1: "French language test preparation: strategy, practice exams, simulations, and feedback.",
    legal_ee_p2: "Profile diagnostic and tailored preparation roadmap.",
    legal_ee_p3: "Document checklists and support for organizing evidentiary records.",
    legal_ee_p4: "Deadline monitoring and practical pre-departure preparation.",
    legal_ee_p5: "Referral to an authorized legal professional whenever formal legal representation or opinions are required.",
    french_test_notice_title: "About the French language test:",
    french_test_notice_body: "TCF Canada exam fees are paid separately to the accredited testing center. JNIC fees cover coaching and training, but guarantee neither a specific test score nor an Invitation to Apply (ITA).",

    // Signatures
    signature_applicant: "Applicant (Acknowledged & Accepted)",
    signature_applicant_receipt: "Applicant (Signatory)",
    signature_agency: "For JNIC (Executive Management & Accounting)",
    signature_accounting: "JNIC Treasury & Accounting Department",
    date_and_signature: "Date & Signature:",
  },
};

// Helper function to format summary text in English or French
export function generateDocumentSummaryText({
  formData,
  calculations,
  docType = "estimate",
  docLang = "fr",
  formatNumber,
}) {
  const isEn = docLang === "en";
  const isReceipt = docType === "receipt";

  const docTitle = isReceipt
    ? (isEn ? "OFFICIAL PAYMENT RECEIPT" : "REÇU OFFICIEL DE PAIEMENT")
    : (isEn ? "OFFICIAL ESTIMATE & BUDGET QUOTATION" : "BUDGET ESTIMATIF");

  const docId = isReceipt ? (formData.receipt_number || formData.estimate_id) : formData.estimate_id;
  const paymentMethodLabel = isReceipt
    ? (isEn
        ? (formData.payment_method === "compte_bloque" ? "🔒 Blocked Escrow Account" : formData.payment_method === "virement" ? "Bank Wire Transfer" : formData.payment_method === "especes" ? "Cash" : formData.payment_method === "carte" ? "Credit/Debit Card" : "Certified Cheque")
        : (formData.payment_method === "compte_bloque" ? "🔒 Compte bloqué (Fonds consignés)" : formData.payment_method === "virement" ? "Virement bancaire" : formData.payment_method === "especes" ? "Espèces" : formData.payment_method === "carte" ? "Carte bancaire" : "Chèque certifié"))
    : null;

  const paymentStatusLabel = isReceipt
    ? (isEn
        ? (formData.payment_status === "fully_paid" ? "✅ Fully Paid (Settled)" : formData.payment_status === "partial" ? "⏳ Partial Deposit Received" : "⏱️ Pending Clearance")
        : (formData.payment_status === "fully_paid" ? "✅ Soldé (Paiement Intégral)" : formData.payment_status === "partial" ? "⏳ Acompte Versé (Paiement Partiel)" : "⏱️ En attente de compensation"))
    : null;

  const amountPaidVal = formData.amount_paid ?? calculations.grandTotalFCFA;
  const balanceDueVal = Math.max(0, calculations.grandTotalFCFA - amountPaidVal);

  if (formData.procedure_type === "work_contract") {
    const familyLabelEn = formData.has_spouse
      ? (formData.children_count === 1
          ? "Couple with 1 child (Official rate: 7,000,000 FCFA)"
          : formData.children_count >= 2
          ? `Family with ${formData.children_count} children (Official rate: 9,000,000 FCFA)`
          : "Couple without children (Rate: 6,000,000 FCFA)")
      : (formData.children_count > 0
          ? `Single parent with ${formData.children_count} child(ren)`
          : "Single applicant (Official rate: 5,000,000 FCFA)");

    const familyLabelFr = formData.has_spouse
      ? (formData.children_count === 1
          ? "Couple avec 1 enfant (Barème officiel : 7 000 000 FCFA)"
          : formData.children_count >= 2
          ? `Famille avec ${formData.children_count} enfants (Barème officiel : 9 000 000 FCFA)`
          : "Couple sans enfant (Barème : 6 000 000 FCFA)")
      : (formData.children_count > 0
          ? `Parent seul avec ${formData.children_count} enfant(s)`
          : "Candidat seul (Barème officiel : 5 000 000 FCFA)");

    if (isEn) {
      return `🇨🇦 ${docTitle} - JN IMMIGRATION CONSULTING (JNIC)
========================================================
${isReceipt ? "Receipt No." : "Ref"}: ${docId} | Date: ${formData.date}
Principal Applicant: ${formData.client_name || "Applicant"}
Procedure: Canada Work Contract (Blocked Escrow Account Procedure)
Family Composition: ${familyLabelEn}
Recruiting Sector: ${formData.work_contract_company_sector || "Nylon paper manufacturing company"}
Payment Scheme: 🔒 Blocked Escrow Account (Guaranteed funds held in trust)
${isReceipt ? `
💳 PAYMENT DETAILS:
• Amount Paid / Received: ${formatNumber(amountPaidVal)} FCFA
• Balance Remaining Due: ${formatNumber(balanceDueVal)} FCFA
• Payment Method: ${paymentMethodLabel}
• Payment Status: ${paymentStatusLabel}
• Payment Reference: ${formData.payment_reference || "N/A"}
` : ""}
📋 BREAKDOWN OF THE TWO PROCEDURE EXPENSES:

1. PROCESSING FEES, LMIA & EMPLOYER DEPOSIT: ${formatNumber(calculations.workContractProcessingFCFA)} FCFA
• Official fees for LMIA (Labour Market Impact Assessment)
• Mandatory deposit paid to recruiting company (${formData.work_contract_company_sector || "Nylon paper manufacturing company"})
• Flight ticket(s) to Canada INCLUDED
• Handover at completion: Flight ticket(s) + Official Employment Contract

2. TECHNICAL ASSISTANCE FOR PROOF OF SETTLEMENT FUNDS: ${formatNumber(calculations.workContractProofFundsFCFA)} FCFA
• Technical banking structuring and complete assembly of required proof of settlement funds

🔒 BLOCKED ACCOUNT ESCROW PROTECTION (MAX DURATION: 6 MONTHS):
• The entire procedure is conducted under a blocked escrow account: your funds remain held in trust and fully protected.
• Maximum duration of fund blocking: 6 months (contractual duration of the procedure).

🛡️ GUARANTEE AND 100% FULL REFUND CLAUSE:
• If the procedure does not succeed, the client is FULLY REFUNDED.
• The blocking of funds lasts a maximum of 6 months: if the procedure has not succeeded within this 6-month limit, the client is ALSO FULLY REFUNDED without delay.
${calculations.hasDiscount ? `
🎁 DISCOUNT / COMMERCIAL COURTESY GRANTED:
• Gross Procedure Subtotal: ${formatNumber(calculations.subtotalFCFA)} FCFA
• Deducted Discount (${formData.discount_reason || "Promotional discount"}): -${formatNumber(calculations.discountAmountFCFA)} FCFA
` : ""}========================================================
💰 ${isReceipt ? "TOTAL DOSSIER AMOUNT" : "TOTAL PROCEDURE ESTIMATE"}: ${formatNumber(calculations.grandTotalFCFA)} FCFA (~ ${formatNumber(calculations.grandTotalCAD)} CAD)${calculations.hasDiscount ? ` (After ${formatNumber(calculations.discountAmountFCFA)} FCFA discount)` : ""}
${isReceipt ? `💵 AMOUNT PAID: ${formatNumber(amountPaidVal)} FCFA | REMAINING: ${formatNumber(balanceDueVal)} FCFA\n` : ""}========================================================

📦 FINAL DELIVERABLES HANDED OVER TO CLIENT AT END OF PROCEDURE:
✔️ Validated official employment contract
✔️ Flight ticket(s) to Canada
✔️ Official Work Permit / Visa

--
JN Immigration Consulting | Douala - Montreal
Email: info@jnic.org | Web: https://jnic.org`;
    }

    // French Work Contract
    return `🇨🇦 ${docTitle} - JN IMMIGRATION CONSULTING (JNIC)
========================================================
${isReceipt ? "Reçu N°" : "Réf"} : ${docId} | Date : ${formData.date}
Candidat Principal : ${formData.client_name || "Client"}
Procédure : Contrat de Travail Canada (Procédure en Compte Bloqué)
Composition Familiale : ${familyLabelFr}
Secteur employeur : ${formData.work_contract_company_sector || "Entreprise de fabrication de papier nylon"}
Mode de règlement : 🔒 Compte bloqué (Fonds consignés et garantis)
${isReceipt ? `
💳 DÉTAILS DU PAIEMENT :
• Montant Réglé / Encaissé : ${formatNumber(amountPaidVal)} FCFA
• Solde Restant Dû : ${formatNumber(balanceDueVal)} FCFA
• Mode de Règlement : ${paymentMethodLabel}
• Statut du Règlement : ${paymentStatusLabel}
• Réf. Transaction / Reçu : ${formData.payment_reference || "N/A"}
` : ""}
📋 DÉTAIL DES DEUX DÉPENSES DE LA PROCÉDURE :

1. FRAIS DE TRAITEMENT, EIMT & CAUTION ENTREPRISE : ${formatNumber(calculations.workContractProcessingFCFA)} FCFA
• Frais officiels pour l'EIMT (Étude d'Impact sur le Marché du Travail)
• Caution versée à l'entreprise qui recrute (${formData.work_contract_company_sector || "Entreprise de fabrication de papier nylon"})
• Billet(s) d'avion pour le Canada INCLUS
• Remise en fin de procédure : Billet(s) d'avion + Contrat de travail

2. ASSISTANCE À LA RÉALISATION DE LA PREUVE DE FONDS : ${formatNumber(calculations.workContractProofFundsFCFA)} FCFA
• Structuration technique et accompagnement complet pour la preuve de fonds exigée

🔒 SÉCURISATION EN COMPTE BLOQUÉ (DURÉE MAX : 6 MOIS) :
• La totalité de la procédure se déroule sous compte bloqué : vos fonds restent consignés et protégés.
• Durée maximale de blocage des fonds : 6 mois (durée contractuelle de la procédure).

🛡️ GARANTIE ET CLAUSE DE REMBOURSEMENT INTÉGRAL :
• Si la procédure n'aboutit pas, le client est ENTIÈREMENT REMBOURSÉ.
• Le blocage des fonds dure 6 mois maximum : si la procédure n'a pas abouti dans ce délai maximal de 6 mois, le client est ÉGALEMENT ENTIÈREMENT REMBOURSÉ sans délai.
${calculations.hasDiscount ? `
🎁 RABAIS / REMISE COMMERCIALE ACCORDÉE :
• Sous-total brut de la procédure : ${formatNumber(calculations.subtotalFCFA)} FCFA
• Remise déduite (${formData.discount_reason || "Remise commerciale"}) : -${formatNumber(calculations.discountAmountFCFA)} FCFA
` : ""}========================================================
💰 ${isReceipt ? "MONTANT TOTAL DU DOSSIER" : "BUDGET ESTIMATIF TOTAL PROCÉDURE"} : ${formatNumber(calculations.grandTotalFCFA)} FCFA (~ ${formatNumber(calculations.grandTotalCAD)} $CAD)${calculations.hasDiscount ? ` (Après déduction du rabais de ${formatNumber(calculations.discountAmountFCFA)} FCFA)` : ""}
${isReceipt ? `💵 MONTANT ENCAISSÉ : ${formatNumber(amountPaidVal)} FCFA | SOLDE DÛ : ${formatNumber(balanceDueVal)} FCFA\n` : ""}========================================================

📦 LIVRABLES REMIS AU CLIENT EN FIN DE PROCÉDURE :
✔️ Contrat de travail officiel validé
✔️ Billet(s) d'avion vers le Canada
✔️ Visa / Permis de travail officiel

--
JN Immigration Consulting | Douala - Montréal
Courriel : info@jnic.org | Web : https://jnic.org`;
  }

  // Express Entry English
  if (isEn) {
    return `🇨🇦 ${docTitle} - JN IMMIGRATION CONSULTING (JNIC)
========================================================
${isReceipt ? "Receipt No." : "Ref"}: ${docId} | Date: ${formData.date}
Principal Applicant: ${formData.client_name || "Applicant"}
Procedure: ${formData.procedure_type === "express_entry_single" ? "Express Entry (Single)" : "Express Entry (Family)"}
Composition: ${calculations.totalFamilyMembers} person(s) ${formData.has_spouse ? "(Couple" : "(Single"}${formData.children_count > 0 ? ` + ${formData.children_count} child(ren))` : ")"}
${isReceipt ? `
💳 PAYMENT DETAILS:
• Amount Paid / Received: ${formatNumber(amountPaidVal)} FCFA
• Balance Remaining Due: ${formatNumber(balanceDueVal)} FCFA
• Payment Method: ${paymentMethodLabel}
• Payment Status: ${paymentStatusLabel}
• Payment Reference: ${formData.payment_reference || "N/A"}
` : ""}
1. PRELIMINARY EVALUATIONS & LANGUAGE TESTS:
• Official TCF/TEF Canada French test (${calculations.numLanguageTests} test(s)): ${formatNumber(calculations.languageTestsTotalFCFA)} FCFA
• University degree verification & transcripts (${calculations.numUniversityProcesses}): ${formatNumber(calculations.universityProcessTotalFCFA)} FCFA
• WES Canada Educational Credential Assessment (${calculations.numWes}): ${formatNumber(calculations.wesTotalFCFA)} FCFA

2. OFFICIAL CANADIAN GOVERNMENT (IRCC) & MEDICAL FEES:
• Upfront IOM Medical Exam (${calculations.medicalTotalUSD} USD): ${formatNumber(calculations.medicalTotalFCFA)} FCFA
• Official IRCC Government fees (${formatNumber(calculations.irccFeesCAD)} CAD): ${formatNumber(calculations.irccFeesTotalFCFA)} FCFA

3. JNIC PROFESSIONAL ADVISORY RETAINER:
• Total immigration guidance retainer: ${formatNumber(calculations.jnicHonorairesFCFA)} FCFA
${formData.include_work_exp_assistance ? `• Work experience formalization: 150,000 FCFA\n` : ""}${formData.include_funds_proof_assistance ? `• Settlement funds structuring (7%): ${formatNumber(calculations.proofOfFundsAssistanceFCFA)} FCFA\n` : ""}${formData.include_contingency ? `• Administrative contingency reserve: 250,000 FCFA\n` : ""}
💳 RETAINER PAYMENT SCHEDULE (3 INSTALLMENTS):
• 1st installment (25%): ${formatNumber(calculations.jnicTranche1FCFA)} FCFA — At start of procedure (File launch)
• 2nd installment (25%): ${formatNumber(calculations.jnicTranche2FCFA)} FCFA — Upon receipt of ITA (IRCC Invitation to Apply)
• 3rd installment (50%): ${formatNumber(calculations.jnicTranche3FCFA)} FCFA — Upon final Visa issuance by IRCC

🛡️ REFUND POLICY IN CASE OF REFUSAL:
In the event of application refusal by IRCC, 50% of the amount already paid is fully refunded to the client (i.e. ${formatNumber(calculations.jnicRemboursementRefusFCFA)} FCFA returned out of ${formatNumber(calculations.jnicTotalVerseAvantVisaFCFA)} FCFA paid prior to visa issuance, the remaining 50% being due only after effective visa issuance).
${calculations.hasDiscount ? `
🎁 DISCOUNT / COMMERCIAL COURTESY GRANTED:
• Gross Procedure Subtotal: ${formatNumber(calculations.subtotalFCFA)} FCFA
• Deducted Discount (${formData.discount_reason || "Promotional discount"}): -${formatNumber(calculations.discountAmountFCFA)} FCFA
` : ""}========================================================
💰 ${isReceipt ? "TOTAL DOSSIER AMOUNT" : "TOTAL PROCEDURE ESTIMATE"}: ${formatNumber(calculations.grandTotalFCFA)} FCFA (~ ${formatNumber(calculations.grandTotalCAD)} CAD)${calculations.hasDiscount ? ` (After ${formatNumber(calculations.discountAmountFCFA)} FCFA discount)` : ""}
${isReceipt ? `💵 AMOUNT PAID: ${formatNumber(amountPaidVal)} FCFA | REMAINING: ${formatNumber(balanceDueVal)} FCFA\n` : ""}========================================================

🏦 OFFICIAL IRCC SETTLEMENT FUNDS REQUIREMENT:
Mandatory unencumbered personal bank balance for ${calculations.totalFamilyMembers} person(s):
➡️ ${formatNumber(calculations.settlementFundsCAD)} CAD (~ ${formatNumber(calculations.settlementFundsFCFA)} FCFA)
(Applicant's personal funds, not collected by JNIC, verified by official bank certificate).

✨ Post-Arrival Services (Optional a la carte): 300,000 FCFA
(Airport pickup, transitional lodging, RAMQ/OHIP card, Canadian bank account, SIN).

--
JN Immigration Consulting | Douala - Montreal
Email: info@jnic.org | Web: https://jnic.org`;
  }

  // Express Entry French
  return `🇨🇦 ${docTitle} - JN IMMIGRATION CONSULTING (JNIC)
========================================================
${isReceipt ? "Reçu N°" : "Réf"} : ${docId} | Date : ${formData.date}
Candidat Principal : ${formData.client_name || "Client"}
Procédure : ${formData.procedure_type === "express_entry_single" ? "Entrée Express (Célibataire)" : "Entrée Express (Couple / Famille)"}
Composition : ${calculations.totalFamilyMembers} personne(s) ${formData.has_spouse ? "(Couple" : "(Seul"}${formData.children_count > 0 ? ` + ${formData.children_count} enfant(s))` : ")"}
${isReceipt ? `
💳 DÉTAILS DU PAIEMENT :
• Montant Réglé / Encaissé : ${formatNumber(amountPaidVal)} FCFA
• Solde Restant Dû : ${formatNumber(balanceDueVal)} FCFA
• Mode de Règlement : ${paymentMethodLabel}
• Statut du Règlement : ${paymentStatusLabel}
• Réf. Transaction / Reçu : ${formData.payment_reference || "N/A"}
` : ""}
1. ÉVALUATION & TESTS DE LANGUE :
• Test de français TCF/TEF Canada (${calculations.numLanguageTests} test(s)) : ${formatNumber(calculations.languageTestsTotalFCFA)} FCFA
• Procédure Université & Authentification (${calculations.numUniversityProcesses}) : ${formatNumber(calculations.universityProcessTotalFCFA)} FCFA
• Évaluation WES Canada (${calculations.numWes}) : ${formatNumber(calculations.wesTotalFCFA)} FCFA

2. FRAIS GOUVERNEMENTAUX & MÉDICAUX :
• Visite médicale préalable OIM (${calculations.medicalTotalUSD} $US) : ${formatNumber(calculations.medicalTotalFCFA)} FCFA
• Frais officiels IRCC gouvernement Canada (${formatNumber(calculations.irccFeesCAD)} $CAN) : ${formatNumber(calculations.irccFeesTotalFCFA)} FCFA

3. HONORAIRES D'ACCOMPAGNEMENT JNIC :
• Total honoraires d'accompagnement : ${formatNumber(calculations.jnicHonorairesFCFA)} FCFA
${formData.include_work_exp_assistance ? `• Assistance formalisation expérience : 150 000 FCFA\n` : ""}${formData.include_funds_proof_assistance ? `• Assistance preuve de fonds (7%) : ${formatNumber(calculations.proofOfFundsAssistanceFCFA)} FCFA\n` : ""}${formData.include_contingency ? `• Réserve imprévus administratifs : 250 000 FCFA\n` : ""}
💳 ÉCHÉANCIER DE PAIEMENT DES HONORAIRES JNIC (3 TRANCHES) :
• 1ère tranche (25%) : ${formatNumber(calculations.jnicTranche1FCFA)} FCFA — Au début de la procédure (Lancement du dossier)
• 2ème tranche (25%) : ${formatNumber(calculations.jnicTranche2FCFA)} FCFA — À la réception de l'ITA (Invitation à présenter une demande)
• 3ème tranche (50%) : ${formatNumber(calculations.jnicTranche3FCFA)} FCFA — À l'émission finale du Visa par IRCC

🛡️ CLAUSE DE GARANTIE & REMBOURSEMENT EN CAS DE REFUS :
En cas de refus de la demande par IRCC, 50% du montant déjà versé est intégralement remboursé au client (soit ${formatNumber(calculations.jnicRemboursementRefusFCFA)} FCFA remboursés sur les ${formatNumber(calculations.jnicTotalVerseAvantVisaFCFA)} FCFA versés avant visa, les 50% restant n'étant exigibles qu'après l'émission effective du visa).
${calculations.hasDiscount ? `
🎁 RABAIS / REMISE COMMERCIALE ACCORDÉE :
• Sous-total brut de la procédure : ${formatNumber(calculations.subtotalFCFA)} FCFA
• Remise déduite (${formData.discount_reason || "Remise commerciale"}) : -${formatNumber(calculations.discountAmountFCFA)} FCFA
` : ""}========================================================
💰 ${isReceipt ? "MONTANT TOTAL DU DOSSIER" : "BUDGET ESTIMATIF TOTAL PROCÉDURE"} : ${formatNumber(calculations.grandTotalFCFA)} FCFA (~ ${formatNumber(calculations.grandTotalCAD)} $CAD)${calculations.hasDiscount ? ` (Après déduction du rabais de ${formatNumber(calculations.discountAmountFCFA)} FCFA)` : ""}
${isReceipt ? `💵 MONTANT ENCAISSÉ : ${formatNumber(amountPaidVal)} FCFA | SOLDE DÛ : ${formatNumber(balanceDueVal)} FCFA\n` : ""}========================================================

🏦 EXIGENCE OFFICIELLE IRCC (PREUVE DE FONDS DE SUBSISTANCE) :
Montant minimum obligatoire requis sur votre compte bancaire personnel pour ${calculations.totalFamilyMembers} personne(s) :
➡️ ${formatNumber(calculations.settlementFundsCAD)} $CAD (~ ${formatNumber(calculations.settlementFundsFCFA)} FCFA)
(Argent propre du client non encaissé par JNIC, justifié par attestation bancaire).

✨ Services Post-Arrivée (Optionnel à la carte) : 300 000 FCFA
(Accueil aéroport, logement transitoire, RAMQ/OHIP, compte bancaire, NAS/SIN).

--
JN Immigration Consulting | Douala - Montréal
Courriel : info@jnic.org | Web : https://jnic.org`;
}
